export default __webpack_public_path__ + "static/media/Frame_195.a67c3827.jpg";